import Chart from "react-apexcharts";

const PieChart = () => {
  const series = [3.7, 35.0, 61.3];

  const options = {
    chart: {
      type: "pie",
      height: 340,
      fontFamily: "IRANSansWeb, sans-serif",
      toolbar: {
        show: false,
      },
    },

    labels: [
      "ارزیابی اولیه",
      "مصوب",
      "بایگانی شده",
    ],

    colors: [
      "#1d3557",
      "#305d98",
      "#3f7bc9",
    ],

    theme: {
      monochrome: {
        enabled: false,
      },
    },

    stroke: {
      width: 1,
      colors: ["#EBEBE9"],
    },

    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
      },
    },

    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "IRANSansWeb",
        colors: ["#ffffff"],
        fontSize: "12px",
        fontWeight: 400,
      },
      formatter: (val) => `${val.toFixed(1)}٪`,
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
      fontFamily: "IRANSansWeb",
      fontSize: "13px",
    },

    tooltip: {
  enabled: false,
},
  };

  return (
    <div dir="rtl">
      <Chart
        options={options}
        series={series}
        type="pie"
        height={340}
      />
    </div>
  );
};

export default PieChart;